'use strict';

import SemanticModule from './semantic/semantic.module';
import CommonModule from './common/common.module';
import ComponentsModule from './components/components.module';

export default angular
  .module('maestro.directives', [
    SemanticModule,
    CommonModule,
    ComponentsModule
  ])
  .name;
